import React, { useState } from "react";
import {
  Box,
  Chip,
  Menu,
  MenuItem,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import { EllipsisVertical } from "lucide-react";

export default ({
  status,
  setStatus,
  paymentDisabled = false,
  loading = false,
  disabled = false,
  onEdit,
}: {
  status: string;
  paymentDisabled?: boolean;
  loading?: boolean;
  disabled?: boolean;
  setStatus: (s: string) => void;
  onEdit?: () => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const values = new Map<string, [string, string, string]>([
    ["pending_approval", ["Pending", "rgba(255, 235, 238, 0.95)", "#D32F2F"]], // Soft pink background, deep red text
    ["approved", ["Approved", "rgba(255, 249, 230, 0.95)", "#D48806"]], // Soft yellow background, deep amber text
    ["paid", ["Paid", "rgba(237, 247, 237, 0.95)", "#388E3C"]], // Soft green background, dark green text
    ["deferred", ["Deferred", "rgba(230, 243, 255, 0.95)", "#1976D2"]], // Soft blue background, deep blue text
    ["archived", ["Archived", "rgba(255, 235, 238, 0.95)", "#D32F2F"]], // Soft pink background, deep red text
    // Remove.
    // ["pending", ["Pending", "rgba(255, 249, 230, 0.95)", "#D48806"]], // Soft yellow background, deep amber text
    // ["unpaid", ["Unpaid", "rgba(255, 235, 238, 0.95)", "#D32F2F"]], // Soft pink background, deep red text
  ]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!loading && !disabled) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (value: string) => {
    if (paymentDisabled && (value === "paid" || value === "approved")) return;
    setStatus(value);
    handleClose();
  };

  const handleApprove = () => {
    if (!paymentDisabled) {
      setStatus("approved");
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
      {status === "pending_approval" ? (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={handleApprove}
          disabled={loading || disabled || paymentDisabled}
        >
          Approve
        </Button>
      ) : (
        <Chip
          label={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100px",
                fontWeight: 500,
              }}
            >
              {values.get(status)?.[0] || "Select Status"}
            </Box>
          }
          style={{
            backgroundColor: values.get(status)?.[1] || "#F5F5F5",
            color: values.get(status)?.[2] || "#000",
            width: "120px",
          }}
          disabled={loading || disabled}
        />
      )}
      <IconButton
        onClick={handleClick}
        disabled={loading || disabled}
        sx={{ height: "32px" }}
      >
        <EllipsisVertical size={20} />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {Array.from(values.entries()).map(([key, [label]]) => (
          <MenuItem
            key={key}
            onClick={() => handleSelect(key)}
            disabled={
              key === status ||
              (paymentDisabled && (key === "paid" || key === "approved"))
            }
          >
            {label}
          </MenuItem>
        ))}
        {onEdit && <Divider />}
        {onEdit && (
          <MenuItem
            onClick={() => {
              onEdit();
              handleClose();
            }}
          >
            Edit invoice
          </MenuItem>
        )}
      </Menu>
    </Box>
  );
};
